'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _objectWithoutPropertiesLoose = require('@babel/runtime/helpers/objectWithoutPropertiesLoose');
var _taggedTemplateLiteralLoose = require('@babel/runtime/helpers/taggedTemplateLiteralLoose');
var React = require('react');
var bumbag = require('bumbag');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _objectWithoutPropertiesLoose__default = /*#__PURE__*/_interopDefaultLegacy(_objectWithoutPropertiesLoose);
var _taggedTemplateLiteralLoose__default = /*#__PURE__*/_interopDefaultLegacy(_taggedTemplateLiteralLoose);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var _excluded = ["children"];

var _templateObject;
var Label = bumbag.styled(bumbag.Label)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose__default["default"](["\n  color: ", ";\n  font-size: 12px;\n  line-height: 2.5;\n  margin-bottom: 0px;\n  text-transform: uppercase;\n"])), bumbag.palette('text100'));
function LabelWrapper(props) {
  var children = props.children,
      restProps = _objectWithoutPropertiesLoose__default["default"](props, _excluded);

  return /*#__PURE__*/React__default["default"].createElement(Label, restProps, children);
}

exports["default"] = LabelWrapper;
